import React from 'react';
import HeroSection from '../components/HeroSection';
import AboutSection from '../components/AboutSection';
import ActivitiesGrid from '../components/ActivitiesGrid';
import { Sparkles, Target, Zap, ShieldCheck } from 'lucide-react';
import { motion } from 'motion/react';
import { useContent } from '../context/ContentContext';

const Home = () => {
  const differentials = [
    {
      title: "Atendimento Integral",
      description: "Abordagem multidisciplinar que cuida do paciente e oferece suporte emocional à família.",
      icon: Target
    },
    {
      title: "Estrutura Adaptada",
      description: "Sede de 376m² com piscina aquecida, studio de pilates e centro de equoterapia próprio.",
      icon: Zap
    },
    {
      title: "Gratuidade Total",
      description: "Todos os nossos serviços são oferecidos sem custo para a população de Iguatemi e região.",
      icon: ShieldCheck
    }
  ];

  return (
    <main>
      <HeroSection />
      
      <AboutSection />

      {/* Activities Preview */}
      <section className="py-24 bg-slate-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col md:flex-row md:items-end justify-between mb-16 gap-6">
            <div className="space-y-4 max-w-2xl">
              <h2 className="text-primary font-bold uppercase tracking-widest text-sm">Nossas Atividades</h2>
              <h3 className="text-4xl font-extrabold text-slate-900 leading-tight">
                Iniciativas que <span className="text-primary">Transformam</span> o Dia a Dia.
              </h3>
            </div>
            <motion.div whileHover={{ x: 5 }}>
              <a href="/atividades" className="text-primary font-bold flex items-center space-x-2 group">
                <span>Ver todas as atividades</span>
                <Sparkles size={18} className="group-hover:rotate-12 transition-transform" />
              </a>
            </motion.div>
          </div>
          
          <ActivitiesGrid limit={3} />
        </div>
      </section>

      {/* Differentials */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-3xl mx-auto mb-16 space-y-4">
            <h2 className="text-primary font-bold uppercase tracking-widest text-sm">Diferenciais</h2>
            <h3 className="text-4xl font-extrabold text-slate-900">Por que escolher nossa organização?</h3>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
            {differentials.map((item, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                className="text-center space-y-6 p-8 rounded-3xl hover:bg-slate-50 transition-colors"
              >
                <div className="w-20 h-20 bg-blue-50 text-primary rounded-full flex items-center justify-center mx-auto shadow-sm">
                  <item.icon size={32} />
                </div>
                <h4 className="text-xl font-bold text-slate-900">{item.title}</h4>
                <p className="text-slate-600 leading-relaxed">{item.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
};

export default Home;
